<template>
  <UserListCard
    v-if="permission >= 1"
    :title="title"
    :widget="widget"
    :view-all-to="viewAllTo"
    @retry="$emit('retry')"
    @page="$emit('page', $event)"
  >
    <b-table
      :items="widget.users"
      :fields="fields"
      primary-key="uuid"
      responsive
      show-empty
    >
      <template #cell(access)="{ item }">
        <span v-if="!item.hasAccess" class="text-muted">{{
          $t("label.dashboardNoAccess")
        }}</span>
        <template v-else-if="item.isLocked">
          <b-button
            v-if="permission === 2"
            variant="link"
            class="text-danger p-0"
            :disabled="busy"
            @click="$emit('unlock', item)"
            >{{ $t("label.dashboardLocked") }}</b-button
          >
          <span v-else class="text-danger">{{
            $t("label.dashboardLocked")
          }}</span>
        </template>
        <span v-else class="text-success">{{
          $t("label.dashboardAccessible")
        }}</span>
      </template>
    </b-table>
  </UserListCard>
</template>
<script>
import UserListCard from "./UserListCard.vue";
export default {
  name: "DashboardLockedUsers",
  components: { UserListCard },
  props: {
    viewAllTo: { type: [String, Object], default: null },
    title: { type: String, required: true },
    accessLabel: { type: String, required: true },
    widget: { type: Object, required: true },
    busy: { type: Boolean, default: false },
    permission: { type: Number, default: 0 },
  },
  computed: {
    fields() {
      return [
        { key: "name", label: this.$t("label.name") },
        { key: "email", label: this.$t("label.email") },
        { key: "access", label: this.accessLabel },
      ];
    },
  },
};
</script>
